import React from "react";
import "./Button.scss";

export default function Button({ text, className, href, newTab }) {
  console.log(href)
  return (
    <div className={className}>
      <a
        className="main-button"
        href={href}
        // Conditionally apply target attribute
        {...(newTab ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        {text}
      </a>
    </div>
  );
}
